module.exports = __webpack_public_path__ + "static/media/key-icon-inactive.82d2532c.svg";